import React from 'react';
import { View } from 'react-native';
import { Text } from '@/components/common/text';
import { AnchoredDropdownItem } from '@/components/common/admin/desktop/dropdown/AnchoredDropdownItem';
import { AnchoredDropdown } from '@/components/common/admin/desktop/dropdown/AnchoredDropdown';
import { SVG_COMPONENTS } from '@/assets/admin';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';
import { useDesktopDropdownStyles } from '@/components/common/admin/desktop/dropdown/DesktopDropdownStyles';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';

// folder.svg, archive.svg and admin.svg bake their stroke in as gray400 and
// ignore `color`; pencil.svg honours it, so it is told the same gray to match.
const SIBLING_STROKE_GRAY = PRIMITIVE_COLORS.gray400;

interface DesktopChatOptionsProps {
  isOpen: boolean;
  anchor: AnchorRect | null;
  onClose: () => void;
  onShowDetails: () => void;
  onEdit: () => void;
  onArchive: () => void;
  onThreadOwner: () => void;
  isArchiving?: boolean;
}

export const DesktopChatOptions: React.FC<DesktopChatOptionsProps> = ({
  isOpen,
  anchor,
  onClose,
  onShowDetails,
  onEdit,
  onArchive,
  onThreadOwner,
  isArchiving = false,
}) => {
  const { admin, redesign } = useAdminColors();
  const styles = useDesktopDropdownStyles();
  const iconColor = redesign.text.primary;

  return (
    <AnchoredDropdown isOpen={isOpen} anchor={anchor} width={260} maxHeight={360} onRequestClose={onClose}>
      <View style={{ backgroundColor: admin.selector.dropdownBg }}>
        <AnchoredDropdownItem
          style={styles.menuItem}
          onPress={() => {
            onClose();
            onShowDetails();
          }}
        >
          <View style={styles.iconWrap}>
            <SVG_COMPONENTS.FOLDER width={18} height={18} color={iconColor} />
          </View>
          <Text style={[styles.menuText, { color: redesign.text.primary }]}>Show Details</Text>
        </AnchoredDropdownItem>

        <AnchoredDropdownItem
          style={styles.menuItem}
          onPress={() => {
            onClose();
            onEdit();
          }}
        >
          <View style={styles.iconWrap}>
            <SVG_COMPONENTS.PENCIL width={18} height={18} color={SIBLING_STROKE_GRAY} />
          </View>
          <Text style={[styles.menuText, { color: redesign.text.primary }]}>Edit Conversation</Text>
        </AnchoredDropdownItem>

        <AnchoredDropdownItem
          style={styles.menuItem}
          onPress={onArchive}
          disabled={isArchiving}
        >
          <View style={[styles.iconWrap, isArchiving ? { opacity: 0.5 } : null]}>
            <SVG_COMPONENTS.ARCHIVE width={18} height={18} color={iconColor} />
          </View>
          <Text style={[styles.menuText, { color: redesign.text.primary }]}>Archive Conversation</Text>
        </AnchoredDropdownItem>

        <AnchoredDropdownItem
          style={styles.menuItem}
          onPress={() => {
            onClose();
            onThreadOwner();
          }}
        >
          <View style={styles.iconWrap}>
            <SVG_COMPONENTS.ADMIN width={18} height={18} color={iconColor} />
          </View>
          <Text style={[styles.menuText, { color: redesign.text.primary }]}>Thread Owner</Text>
        </AnchoredDropdownItem>
      </View>
    </AnchoredDropdown>
  );
};
